import {UserContractualDataFormModal} from '@/features/users/components/user-contractual-data-form-modal/UserContractualDataFormModal'
import {useUserFormSubmission} from '@/features/users/hooks/useUserFormSubmission'
import {useUpdateUser} from '@/features/users/queries/useUpdateUser'
import {useUserDetailsStore} from '@/features/users/store/userDetailsStore'
import {UserContractualDataFormValidationSchema, UserExtended} from '@/features/users/types'
import {remapUserToPayload} from '@/features/users/utils'
import {FormProvider, useFormContext} from 'react-hook-form'

export const UserDetailInformationContractDataModal = ({user}: {user: UserExtended}) => {
    const form = useFormContext<UserContractualDataFormValidationSchema>()

    const isContractTypeModalVisible = useUserDetailsStore(state => state.isContractTypeModalVisible)
    const setIsErrorBannerVisible = useUserDetailsStore(state => state.setIsErrorBannerVisible)
    const {onSuccessSubmit, onErrorSubmit, scrollToTop} = useUserFormSubmission({
        formSchema: UserContractualDataFormValidationSchema
    })

    // mutation
    const updateUser = useUpdateUser({
        urlParams: {userId: user.id},
        params: {responseType: 'extended'},
        options: {
            onSuccess: onSuccessSubmit,
            onError: onErrorSubmit
        }
    })

    const handleSubmit = form.handleSubmit(
        formValues => {
            const parsedValues = remapUserToPayload(formValues)
            return updateUser.mutate(parsedValues)
        },
        errors => {
            console.error(errors)
            setIsErrorBannerVisible(true)
            scrollToTop()
        }
    )

    if (!isContractTypeModalVisible) return null

    return (
        <FormProvider {...form}>
            <UserContractualDataFormModal
                onConfirmUpdate={handleSubmit}
                isLoading={updateUser.isPending}
                onCancel={() => {
                    form.resetField('contractType')
                    form.resetField('vatNumber')
                    form.resetField('weeklyHours')
                    form.resetField('raExempt')
                    form.resetField('paymentMethod')
                    form.resetField('iban')
                }}
            />
        </FormProvider>
    )
}
